// extracted by mini-css-extract-plugin
module.exports = {"smallLoader":"e-z","loader":"f-z","loading-keyframes":"g-z","pageLoader":"h-z","centered":"i-z","whitespacePlaceholder":"j-z","buttonSpinner":"k-z","fade-in":"l-z","rotate":"m-z"};